module.exports = __webpack_public_path__ + "media/images/Linkedin-bf00301748795422b63a5971f4c6302b.png";